import semver from "semver";

export const sortVersionsDescending = <T extends { version: string }>(
  versions: T[]
) => [...versions].sort((a, b) => semver.rcompare(a.version, b.version));
